import styled from 'styled-components';
import Button from '../StoraEnsoComponents/Button';

export const InputWrapper = styled.div`
  margin-bottom: 14px;

  label,
  input {
    display: block;
  }

  label {
    margin-bottom: 0.5rem;
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Content = styled.div`
  background-color: ${({theme}) => theme.colors.bg_gray_light};
  padding: 16px;
  height: 100%;
`;

export const SectionLabel = styled.span`
  display: block;
  font-size: 16px;
  font-weight: bold;
  margin: 0 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  ${Button} {
    margin-left: 8px;
  }
`;

export const SelectWrapper = styled.div`
 margin-bottom: 14px;

label,
input {
  display: block;
  text-align: left;
  width: auto;
}

label {
  margin-bottom: 0.5rem;
}
`;
